import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/bcn-logo-horiz-r.jpg")